const initialState = {
  vaccine: [],
  sutkeriSewa: [],
  prasutiSewa: [],
  childVac: [],
  pregVac: [],
  getState: 0,
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_VACCINE_DATA_FULFILLED':
      return { ...state, getState: 2, vaccine: action.payload.data }
    case 'GET_VACCINE_DATA_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_VACCINE_DATA_PENDING':
      return { ...state, getState: 1 }

    case 'GET_SUTKERISEWA_FULFILLED':
      return { ...state, getState: 2, sutkeriSewa: action.payload.data }
    case 'GET_SUTKERISEWA_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_SUTKERISEWA_PENDING':
      return { ...state, getState: 1 }

    case 'GET_PRASUTISEWA_FULFILLED':
      return { ...state, getState: 2, prasutiSewa: action.payload.data }
    case 'GET_PRASUTISEWA_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_PRASUTISEWA_PENDING':
      return { ...state, getState: 1 }

    case 'GET_CHILD_VACCINATION_FULFILLED':
      return { ...state, getState: 2, childVac: action.payload.data }
    case 'GET_CHILD_VACCINATION_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_CHILD_VACCINATION_PENDING':
      return { ...state, getState: 1 }

    case 'GET_PREGNANCY_VACCINATION_FULFILLED':
      return { ...state, getState: 2, pregVac: action.payload.data }
    case 'GET_PREGNANCY_VACCINATION_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_PREGNANCY_VACCINATION_PENDING':
      return { ...state, getState: 1 }
    default:
      return state
  }
}

export default reducer
